import { Box, CircularProgress, Typography } from '@mui/material';

/**
 * Componente de estado de carregamento padronizado
 * 
 * @param {string} message - Mensagem a ser exibida (opcional)
 * @param {number} size - Tamanho do spinner (padrão: 60)
 * 
 * @example
 * {loading && <LoadingState message="Carregando serviços..." />}
 */
export default function LoadingState({ message = 'Carregando...', size = 60 }) {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      py={8}
      minHeight={300}
    >
      <CircularProgress size={size} />
      <Typography variant="body1" mt={2} color="text.secondary">
        {message}
      </Typography>
    </Box>
  );
}
